export const UK_WAREHOUSE_DELIVERY_MESSAGE =
  "This product will be shipped from the UK; please expect 4-7 days for delivery.";

/**
 * True when a product's tags include the UK warehouse tag, allowing for
 * spacing/underscore variations set in Shopify (e.g. "UK Warehouse").
 */
export function hasUkWarehouseTag(tags = []) {
  return (tags || []).some((tag) => {
    const normalizedTag = String(tag)
      .trim()
      .toLowerCase()
      .replace(/[_\s]+/g, "-");
    return normalizedTag === "uk-warehouse";
  });
}
